import { DataGridProProps } from '@mui/x-data-grid-pro';
import { createContext, useContext } from 'react';

import { AllocatedLineItemMapping } from 'common/src/allocations/allocatedLineItemMappings';
import { IUpdateAllocationsDto } from 'common/src/types/bill.dtos';
import {
  IAccount,
  IAllocationTemplate,
  IBill,
  ILineItem,
  ILineItemSubtype,
  IMeter,
} from 'common/src/types/interfaces';

import { IBillHeaderForm } from './BillFormProvider';

export interface IBillFormContext {
  account: Partial<IAccount>;
  accountId: string;
  accountMeters: {
    data: Partial<IMeter>[];
    isError: boolean;
    isFetching: boolean;
  };
  accounts: {
    data: Partial<IAccount>[];
    isError: boolean;
    isFetching: boolean;
  };
  allocatedLineItemMappings: {
    data: AllocatedLineItemMapping[];
    isError: boolean;
    isFetching: boolean;
  };
  allocationMeters: {
    data: Partial<IMeter>[];
    isError: boolean;
    isFetching: boolean;
  };
  allocations: Partial<IBill>[];
  activeAllocationTemplate: IAllocationTemplate;
  bill: Partial<IBill>;
  billIsUsedInAllocations: boolean;
  fetchAllocationPreview: () => void;
  generateNewBillLineItems: () => void;
  getBillPayload: () => Partial<IBill>;
  getUpdateAllocationsPayload: () => IUpdateAllocationsDto;
  onLineItemEditStateChange: (hasUnsavedLineItemEdits: boolean) => void;
  headerForm: IBillHeaderForm;
  lineItems: Partial<ILineItem>[];
  lineItemSubtypes: {
    data: ILineItemSubtype[];
    isError: boolean;
    isFetching: boolean;
  };
  previousBill: {
    data: IBill;
    isError: boolean;
    isLoading: boolean;
  };
  processAllocationLineItemEdit: DataGridProProps['processRowUpdate'];
  resetAllocationLineItems: () => void;
  setAccountId: (id: string) => void;
  setBill: (bill: IBill) => void;
  setLineItems: (lineItems: Partial<ILineItem>[]) => void;
  subAccounts: Partial<IAccount>[];
  total: number;
  validate: (onSuccess: () => void) => Promise<void>;
}

export const BillFormContext = createContext<IBillFormContext | null>(null);

export const useBillFormContext = () =>
  useContext<IBillFormContext>(BillFormContext);
